
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 9717","d":"M27 0A27 27 0 110 27 27 27 0 0127 0z","fill":"#ed3540"}}),_c('g',{attrs:{"data-name":"Group 3124","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 11389","d":"M27.706 26.999l8.645-8.647a.5.5 0 10-.706-.707l-8.648 8.648-8.647-8.647a.5.5 0 00-.706.707L26.29 27l-8.646 8.646a.5.5 0 00.708.707l8.646-8.646 8.646 8.646a.5.5 0 10.708-.707L27.706 27z"}}),_c('path',{attrs:{"data-name":"Path 11389 - Outline","d":"M35.997 36.999a.994.994 0 01-.707-.292l-8.293-8.293-8.292 8.292a1 1 0 01-1.415-1.414L25.583 27l-8.293-8.293a1 1 0 011.413-1.414l8.293 8.293 8.292-8.293a1 1 0 111.411 1.416L28.41 27l8.293 8.293a1 1 0 01-.706 1.706zm-9-10l-9 9 9.283-9.282zm.5.5l8.5 8.5z"}})])])
          )
        }
      }
    